/* eslint semi: 1 */

import _ from 'lodash';

import { t } from '@/i18n/i18ns';
import { asyncFormValidation, asyncValidationRule } from '@/element-ui/form-utils';
import { PageResponse } from '../player-setup-communication';
import OnEnterMixin from '@/components/mixins/onenter-mixin';
import PlayerSetupFormError from '../player-setup-form-error/player-setup-form-error-tmpl';
import CommonOptionsMixin from '@/components/mixins/common-options-mixin';

export const validateName = asyncValidationRule(async (rule, value) => {
  if (!value || value.trim() === '') {
    return new Error(t('playerSetup.requiredPlayerName'));
  }
});

export default {
  name: 'player-setup-name',
  components: {
    PlayerSetupFormError
  },
  mixins: [CommonOptionsMixin, OnEnterMixin],
  props: {
    nextPage: {
      type: [String, Object, null],
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    serial: {
      type: [String, null],
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
      default: 'Europe/Zurich'
    },
    externalError: {
      type: [String, null],
      default: null
    }
  },
  data () {
    return {
      isFormDisabled: false,
      formError: '',
      model: {
        name: '',
        timezone: ''
      },
      timezones: [],
      modelRules: {
        name: [
          { validator: validateName, trigger: 'blur' }
        ],
        timezone: [
          { required: true, trigger: 'blur' }
        ]

      }
    };
  },
  watch: {
    name (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.model.name = newVal;
        // if it's empty then do not show validation right away
        if (newVal === '') {
          this.$refs.refFormName.clearValidate();
        }
      }
    },
    timezone (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.model.timezone = newVal;
      }
    },
    isActive: {
      immediate: true,
      handler (val) {
        if (val) {
          this.refreshForm();
        }
      }
    },
    externalError: {
      immediate: true,
      handler (val) {
        if (val) {
          this.formError = val;
        }
      }
    }
  },
  mounted () {
    if (this.$refs.nameInput) {
      this.$refs.nameInput.focus();
    }

    this.timezones = this.customTimeZone().map((zone) => ({
      id: zone.value + ' - ' + zone.label,
      ...zone
    }));

    // initialize form values
    this.model.timezone = this.timezone;
    this.model.name = this.name;
  },
  methods: {
    /**
     * Remove validation results from the screen and focus primary input
     */
    refreshForm () {
      this.formError = '';
      if (this.$refs.refFormName) {
        this.$refs.refFormName.clearValidate();
      }
      if (this.$refs.nameInput) {
        this.$refs.nameInput.focus();
      }
    },
    onEnter (event) {
      this.triggerFormSubmit();
    },
    toggleFormState (idDisabled) {
      this.isFormDisabled = idDisabled;
    },

    /**
     * This is pattern to perform form validation and easily to test it
     */
    async validateForm (validateFn = asyncFormValidation) {
      this.toggleFormState(true);
      const isFormValid = await validateFn(this.$refs.refFormName);
      this.toggleFormState(false);
      return isFormValid;
    },
    async submitForm () {
      const isFormValid = await this.validateForm();

      if (!isFormValid) {
        this.$refs.nameInput.focus();
        return PageResponse(true);
      }
      // Note: this is to cover default vs selected values
      let timezone = this.timezone;
      if (_.isObject(this.model.timezone)) {
        timezone = this.model.timezone.value;
      }

      this.$refs.timezoneInput.blur();

      return PageResponse(false, this.nextPage, {
        timezone,
        name: this.model.name.trim()
      });
    },
    async triggerFormSubmit (event) {
      this.$emit('SubmitForm');
      return false;
    }
  }
};
